import { Column } from "react-table";

import { ITableProps } from "src/library/components/Tables/Table";
import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";
import { IProcessJobError } from "src/core/process-job/api/processJobs.api";

export type ICustomerImportErrorsColumns = Partial<ITableProps>;

export const customerImportErrorsTableColumns = (): Array<Column<IProcessJobError<"import-file-price">>> => [
  globalTableColumns.id(),
  globalTableColumns.standardText({
    Header: "Line Number",
    accessor: "data.LineNumber",
    width: 100,
    sortable: false,
    filterable: false
  }),
  globalTableColumns.standardText({
    Header: "Message",
    accessor: "message",
    multiLine: true,
    width: 300
  }),
  globalTableColumns.standardText({
    Header: "Customer Code",
    accessor: "data.CustomerCode",
    width: 150,
    sortable: false,
    filterable: false
  }),
  globalTableColumns.standardText({
    Header: "Branch Code",
    accessor: "data.BranchCode",
    width: 150,
    sortable: false,
    filterable: false
  }),
  globalTableColumns.standardText({
    Header: "Price Code",
    accessor: "data.PriceCode",
    width: 150,
    sortable: false,
    filterable: false
  })
];
